import jJoanaList from '@/views/joanadb/jJoanaList';
import jDataset from '@/views/joanadb/dataset/jDataset';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/joana',
    name: 'jJoanaList',
    component: jJoanaList,
    meta: {
      title: 'Big Data Engine',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/joana/dataset/:id',
    name: 'jDataset',
    component: jDataset,
    meta: {
      title: 'Big Data Engine',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterJoana.js